import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monUnderscoreless',
    standalone: false,
})
export class UnderscorelessPipe implements PipeTransform {
    transform (input: string): string {
        if (!input) {
            return '';
        }
        return input.replace(/_/g, ' ');
    }
}
